import { PackageDetailsByPatientId } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";

export default async function getPackageDetailsByTransactionId({
  transactionId,
  inclusionId,
}: {
  transactionId?: number;
  inclusionId?: number;
}): Promise<PackageDetailsByPatientId> {
  const headers = new Headers();

  headers.append("accept", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    headers,
    credentials: "include",
  };

  const TRYST_HOST = GET_TRYST_HOST();
  let url = `${TRYST_HOST}/package/detail`;
  if (transactionId) {
    url += `/${transactionId}`;
  }
  if (inclusionId) {
    url += `?inclusion_id=${inclusionId}`;
  }
  const response = await fetch(url, requestOptions);

  const _data = await response.json();
  return _data?.data;
}
